import { useExperimentEditorContext } from "../context/ExperimentEditorContext";

export const useExperimentEditor = () => useExperimentEditorContext();
